export const LOGINMODUL_CHANGEPASS_REQUEST = "LOGINMODUL_CHANGEPASS_REQUEST";
export const LOGINMODUL_CHANGEPASS_SUCCESS = "LOGINMODUL_CHANGEPASS_SUCCESS";
export const LOGINMODUL_CHANGEPASS_FAIL = "LOGINMODUL_CHANGEPASS_FAIL";
export const LOGINMODUL_CHANGEPASS_RESET = "LOGINMODUL_CHANGEPASS_RESET";
